<mat-toolbar>
  <div class="action-bar-content">
    <ng-content></ng-content>
  </div>
</mat-toolbar>
